<!-- <mat-grid-list class="background-white" cols="4" rowHeight="75px" gutterSize="10px">
    <mat-grid-tile [colspan]="4" [rowspan]="2">
        <div class="top-bar">
            <div class="grid-content">
                <div>Bottler</div>
                <div>
                    <img src="../../assets/landing-logo-group.svg" />
                </div>
            </div>
        </div>
    </mat-grid-tile>

</mat-grid-list> -->

<div class="wrapper">
  <div class="app-bar">
    <div class="profile-menu">
      <!-- <mat-icon *ngIf="admin_flag == '2'" [matMenuTriggerFor]="menu"
        >person_outline</mat-icon
      >
      <mat-icon *ngIf="admin_flag == '1'" [matMenuTriggerFor]="menu"
        >person_outline</mat-icon
      > -->
      <mat-icon 
        >person_outline</mat-icon
      >
      <span *ngIf="user_info_data">{{ user_type }}</span>
      <!-- <mat-menu #menu="matMenu" class="logout-menu">
        <button
          style="
            font-size: 0.95vw;
            font-weight: 500;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
          "
          *ngFor="let u of ['Admin', 'User']"
          (click)="userAdminInterChange(u)"
          mat-menu-item
        >
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 10px;
            "
          >
            <span>{{ u }}</span>
          </div>
        </button>
      </mat-menu> -->
    
    </div>
    <div class="logo">
      <img src="../../assets/landing-logo-group.svg" />
    </div>
  </div>
  <div class="main-title-wrapper">
    <h1 class="title">PlanoPro tool</h1>
    <div *ngIf="user_info_data" class="subtitle">
      <!-- Shopper insights bagged planogramming with regional PicOS -->
      {{ user_info_data.tool_description }}
    </div>
  </div>
  <div class="content">
    <mat-grid-list class="mat-grid-list" cols="4" gutterSize="0px">
      <mat-grid-tile class="image-container" [colspan]="2">
        <img
          src="../../assets/landing-vector-illustration-new.webp"
          width="660.59px"
          height="637px"
        />
      </mat-grid-tile>
      <mat-grid-tile
        *ngIf="user_type !== 'Admin'"
        class="button-container"
        [colspan]="2"
      >
        <div class="button-wrapper-user">
          <mat-card (click)="moveToPlanogramLibrary()" class="red-mat-wide-card">
            <div
              
              class="card-content-wrapper"
            >
              Saved Outputs
              <button mat-button class="card-content-button">
                {{ created_planograms ? created_planograms : 0 }} /
                {{ possible_planograms ? possible_planograms : 0 }} planograms
                created
              </button>
            </div>
          </mat-card>
          <mat-card (click)="addNewPlanogram()" class="red-mat-wide-card">
            Create New Planograms
          </mat-card>
          <div class="small-button-wrapper">
            <!-- <button mat-button class="grey-button">
              <img
                src="../../assets/road-map-logo.svg"
                width="14px"
                height="14px"
              />
              View Science Behind
            </button> -->
            <button
              (click)="openUserSupportDialog()"
              mat-button
              style="width: 103px"
              class="grey-button"
            >
              <img src="../../assets/support.svg" width="14px" height="14px" />
              Support
            </button>
          </div>
        </div>
      </mat-grid-tile>
      <mat-grid-tile
        *ngIf="user_type == 'Admin'"
        class="button-container"
        [colspan]="2"
      >
        <div class="button-wrapper">
          <mat-card class="red-mat-card" (click)="moveToUserAnalyticsScreen()">
            User Analytics
          </mat-card>
          <mat-card
            (click)="moveToAdminGuidelinesUpdate()"
            class="red-mat-card"
          >
            Update Guidelines
          </mat-card>
          <mat-card (click)="moveToDataSetUpdateScreen()" class="red-mat-card">
            Dataset Update
          </mat-card>
          <mat-card
            class="red-mat-card"
            (click)="moveToCustomPlanogramScreen()"
          >
            Custom Planogram
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</div>
<app-loader [is_show_loader]="(loader | async)! || is_show_loader"></app-loader>
